import { jsx as C } from "react/jsx-runtime";
const n = ({
  width: o,
  height: r,
  className: t
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 15 15",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M10.4766 0.948181C11.8548 0.948217 12.9618 2.09146 12.9619 3.4599C12.9619 4.84954 11.834 5.97158 10.4766 5.97162C9.77912 5.97162 9.13887 5.67375 8.68848 5.18744L5.62695 6.78998C5.73995 7.08324 5.82031 7.40875 5.82031 7.75385C5.82028 8.09413 5.75853 8.42111 5.63379 8.72064L8.68848 10.3183C9.13649 9.83294 9.76077 9.53607 10.4766 9.53607C11.8323 9.53611 12.9813 10.6557 12.9814 12.0468C12.9814 13.4356 11.8735 14.5584 10.4961 14.5585C9.11776 14.5585 8.01074 13.4153 8.01074 12.0468C8.01078 11.7624 8.05731 11.5092 8.13379 11.2626L4.99902 9.63275C4.55546 10.0423 3.9731 10.2841 3.33496 10.2841C1.95689 10.2839 0.849754 9.14165 0.849609 7.77338C0.849609 6.40485 1.97667 5.26166 3.31641 5.26166C3.95449 5.26175 4.53696 5.5034 4.98047 5.91302L8.11426 4.28217C8.03801 4.03589 7.99121 3.783 7.99121 3.49896C7.99127 2.1337 9.09513 0.948181 10.4766 0.948181ZM10.4766 10.5966C9.69257 10.5966 9.06366 11.2305 9.06348 12.0273C9.06348 12.823 9.71056 13.4589 10.4766 13.4589C11.2425 13.4589 11.8896 12.823 11.8896 12.0273C11.8895 11.2305 11.2605 10.5967 10.4766 10.5966ZM3.33496 6.34271C2.55223 6.34293 1.92188 6.99485 1.92188 7.77338C1.92202 8.56887 2.56921 9.20383 3.33496 9.20404C4.09968 9.20404 4.74887 8.5507 4.74902 7.77338C4.74902 6.97762 4.10097 6.34271 3.33496 6.34271ZM10.4766 2.08783C9.69128 2.08783 9.06353 2.72278 9.06348 3.49896C9.06348 4.29834 9.69483 4.94916 10.4766 4.94916C11.2594 4.94912 11.8896 4.29713 11.8896 3.51849C11.8896 2.7228 11.2425 2.08787 10.4766 2.08783Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0.3"
      }
    )
  }
);
export {
  n as Content
};
